import React from "react";
import { Divider, Grid, Typography } from "@mui/material";
import { MODES_OPTIONS } from "@app/types/generics.types";
import { MTextField, ResponsiveFormContainer } from "@app/components";
import TritioForm from "./tritioForm";

interface PesadaVolumenFormProps {
  mode: MODES_OPTIONS;
}

const PesadaVolumenForm = ({ mode }: PesadaVolumenFormProps) => {
  const isView = mode === MODES_OPTIONS.VIEW;

  return (
    <>
      <Divider />
      <Grid item xs={12} my={3}>
        <Typography variant="tagText">{"Pesada y volumen"}</Typography>
      </Grid>
      <Grid item xs={12} my={3}>
        <Typography variant="tagText">
          {"Patrones primario y secundario"}
        </Typography>
      </Grid>
      <ResponsiveFormContainer columns={2}>
        <MTextField
          name="eumpp"
          label="Incertidumbre de la balanza a aplicar en incertidumbre masa patrón primario (mpp) para K=2 (mg)"
          placeholder="Para que el analista sepa cual indicar: aplica la incertidumbre máxima para una masa de 200 g"
          type="number"
          fullWidth
          validation={{ required: "El valor es requerido" }}
          disabled={isView}
        />
        <MTextField
          name="eumps"
          label="Incertidumbre masa patrón secundario (umps) para k=2 (mg)"
          placeholder="Aplica la incertidumbre máxima para una masa de 200 g"
          type="number"
          fullWidth
          validation={{ required: "El valor es requerido" }}
          disabled={isView}
        />
        <MTextField
          name="mass_uncertainty_tertiary_pattern"
          label="Incertidumbre de la balanza a aplicar en incertidumbre masa patrón terciario (mpt) para K=2 (mg)"
          placeholder="Aplica la incertidumbre máxima para una masa de 200g"
          type="number"
          fullWidth
          validation={{ required: "El valor es requerido" }}
          disabled={isView}
        />
        <MTextField
          name="euvps_btr"
          label="Incertidumbre a aplicar en incertidumbre para el volumen de patrón secundario en BT/R para K=2 (ml)"
          placeholder="Aplica la incertidumbre máxima para un volumen entre 25 y 500 ml"
          type="number"
          fullWidth
          validation={{ required: "El valor es requerido" }}
          disabled={isView}
        />
      </ResponsiveFormContainer>
      <Grid item xs={12} my={3}>
        <Typography variant="tagText">
          {"Patrones secundario en fuentes de calibración"}
        </Typography>
      </Grid>
      <ResponsiveFormContainer columns={2} mb={3}>
        <MTextField
          name="eumps_h3"
          label="Incertidumbre de la balanza a aplicar en incertidumbre en masa de patrón secundario en fuente de calibración de tritio, para K=2 (mg)"
          placeholder="Aplica la incertidumbre máxima para una masa de 10 g"
          type="number"
          fullWidth
          validation={{ required: "El valor es requerido" }}
          disabled={isView}
        />
        <MTextField
          name="eump_k40"
          label="Incertidumbre de la balanza a aplicar en incertidumbre en masa de patrón secundario en fuente de calibración de K-40 en BT/R y en AT (C), para K=2 (mg)"
          placeholder="Aplica la incertidumbre máxima para una masa de 100 g"
          type="number"
          fullWidth
          validation={{ required: "El valor es requerido" }}
          disabled={isView}
        />
        <MTextField
          name="euvps"
          label="Incertidumbre a aplicar en incertidumbre para volumen de patrón secundario en fuente de calibración para K=2 (ml)"
          placeholder="Aplica la incertidumbre máxima de un volumen entre 1 y 2 ml"
          type="number"
          fullWidth
          validation={{ required: "El valor es requerido" }}
          disabled={isView}
        />
        <MTextField
          name="uncertainty_source_pat_terc"
          label="Incertidumbre de la balanza a aplicar en incertidumbre de masa patrón terciario en fuente de calibración de Fe y Ni, para K=2 (mg)"
          placeholder="Aplica la incertidumbre máxima para una masa de 1g"
          type="number"
          fullWidth
          validation={{ required: "El valor es requerido" }}
          disabled={isView}
        />
      </ResponsiveFormContainer>
    </>
  );
};

export default PesadaVolumenForm;
